import { Injectable } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LookupField } from 'src/app/core/api.gen';
import { CommonService } from 'src/app/core/common.service';
import { getArrayPickerField, getMergedConfig } from 'src/app/shared/form';
import {
  checkRange,
  getDateField, getInputField, getSelectField, getTelephoneField, MinMaxAgeMustBe,
  setAsDisabled,
  setAsNumeric,
  setAsRequired, setDisableWhen, setDisablewithValueWhen, setRegexValidation, setRequiredWhen,
  setAsHiddenWithoutValueWhen,
  setRegexValidationWhen,
  setRequiredAndDisabledBasedOnNationalityType,
} from 'src/app/shared/form/form-utils';
import { LookupTypeKeys } from 'src/app/shared/lookup-type-keys';
import { StepType } from 'src/app/shared/shared.module';
import { isNullOrUndefined } from '../../../app/core/utils';
import { FieldTooltip } from '../../immigration/services/visatypes/field-tooltip.enum';
import { setAsDisabledWhen, setAsHiddenWhen, ValidateFutureDate } from '../../shared/form';
import { nullSafe } from '../../utils';

@Injectable({
  providedIn: 'root'
})
export class UserProfileStepService {
  model: any; // Add this property to resolve the error

  protected nationality$: Observable<LookupField[]>;
  protected passportType$: Observable<LookupField[]>;
  protected onBoardingTypes$: Observable<LookupField[]>;
  protected globalEmployeeLocationCountries$: Observable<LookupField[]>;
  protected officeLocationContries$: Observable<LookupField[]>;
  private officeLegalEntities$: Observable<LookupField[]>;
  private serviceLines$: Observable<LookupField[]>;
  private subServiceLines$: Observable<LookupField[]>;
  private ranks$: Observable<LookupField[]>;
  private yesNo$: Observable<LookupField[]>;
  private officeLocation$: Observable<LookupField[]>;
  private gender$: Observable<LookupField[]>;
  private currentVisaStatus$: Observable<LookupField[]>;
  private maritalStatus$: Observable<LookupField[]>;
  private preboardingType$: Observable<LookupField[]>;
  private nationalityType$: Observable<LookupField[]>;

  protected employeeCategorys$: Observable<LookupField[]>;
  private contractTypes$: Observable<LookupField[]>;
  private workPermit$: Observable<LookupField[]>;
  protected categoryOfJobOfferWithBehaviourSub$: Observable<LookupField[]>;
  protected isYourSpouseCurrentlyWorkingForEY$: Observable<LookupField[]>;
  private visaAlignment$: Observable<LookupField[]>;
  private typeOfVisa$: Observable<LookupField[]>;
  private workpermitJobTitles$: Observable<LookupField[]>;

  empOfficeLocationCountry: () => number;
  nationalityCurrentLocation: () => number;
  empNationalityType: () => number;
  isGCCNationals: () => boolean;
  isVisaApproverView: () => boolean;
  isVisaApprover: () => boolean;
  constructor(private common: CommonService) {
   // this.loadLookups();
     this.nationality$ = this.common.prepareLookupObservable(
      LookupTypeKeys.NATIONALITY
    );
    this.officeLegalEntities$ = this.common.prepareOfficeEntityObservable();
    this.serviceLines$ = this.common.prepareServiceLineObservable();
    this.subServiceLines$ = this.common.prepareSubServiceLineObservable();
    this.yesNo$ = this.common.prepareLookupObservable(LookupTypeKeys.YESNO_TYPES);
    this.gender$ = this.common.prepareLookupObservable(LookupTypeKeys.GENDER);
    this.currentVisaStatus$ = this.common.prepareLookupObservable(LookupTypeKeys.CURRENT_VISA_STATUS);
    this.maritalStatus$ = this.common.prepareLookupObservable(LookupTypeKeys.MARITAL_STATUS);
    this.preboardingType$ = this.common.prepareLookupObservable(LookupTypeKeys.ONBOARDING_TYPES);
    this.categoryOfJobOfferWithBehaviourSub$ = this.common.prepareCategoryOfJobOfferAsBehaviourSub();
    this.employeeCategorys$ = this.common.prepareLookupObservable(
      LookupTypeKeys.EMPLOYEE_CATEGORY_TYPES
    );
    this.typeOfVisa$ = this.common.prepareLookupObservable(LookupTypeKeys.TYPE_OF_VISA);
    this.officeLocation$ = this.common.prepareLookupObservable(LookupTypeKeys.OFFICE_LOCATION);
    this.visaAlignment$ = this.officeLocation$;
    this.workpermitJobTitles$ = this.common.prepareWorkPermitJobTitleObservable();

    // this.gender$ = this.common.prepareLookupObservable(
    //   LookupTypeKeys.GENDER
    // );

    // this.officeLocation$ = this.common.prepareOfcLocationsWithCountryCode();


    // this.allOfficeLocation$ = this.common.GetAllOfficeLocation();

    // this.allForeignOfficeLocation$ = this.common.GetAllForeignOfficeLocation();


    // this.subSubServiceLines$ = this.common.prepareSMUObservable();

    this.onBoardingTypes$ = this.common.prepareLookupObservable(
      LookupTypeKeys.ONBOARDING_TYPES
    );
    this.ranks$ = this.common.prepareLookupObservable(LookupTypeKeys.RANK);
    // this.immigrationCaseType$ = this.common.prepareLookupObservable(
    //   LookupTypeKeys.IMMIGRATION_CASE_TYPE
    // );

    // this.entryType$ = this.common.prepareLookupObservable(
    //   LookupTypeKeys.ENTRY_TYPEs
    // );
    // this.residencyStatus$ = this.common.prepareLookupObservable(
    //   LookupTypeKeys.RESIDENCY_STATUS
    // );

    // this.businessVisaDurationOfStay$ = this.common.prepareLookupObservable(
    //   LookupTypeKeys.BUSINESS_VISA_DURATION_OF_STAY
    // );

    this.globalEmployeeLocationCountries$ = this.common.prepareLookupObservable(
      LookupTypeKeys.EMPLOYEE_CURRENT_LOCATION_COUNTRY
    );
    this.officeLocationContries$ = this.common.prepareLookupObservable(
      LookupTypeKeys.OFFICE_LOCATION_COUNTRY
    );
    this.contractTypes$ = this.common.prepareLookupObservable(
      LookupTypeKeys.MOL_CONTRACT
    );
    this.workPermit$ = this.common.prepareLookupObservable(
      LookupTypeKeys.WORK_PERMIT_TYPE
    );

    this.nationalityType$ = this.common.prepareLookupObservable(
      LookupTypeKeys.NATIONALITY_TYPE
    );
    // this.yesNo$ = this.common.prepareLookupObservable(
    //   LookupTypeKeys.YESNO_TYPES
    // );
    // this.ImmStatus$ = this.common.prepareLookupObservable(LookupTypeKeys.IMMIGRATION_STATUSES);

    // this.recruiters$ = this.common.prepareEmployeeByRoleObservable(RoleType.Recruiter);
    // this.employees$ = this.common.prepareEmployeeByRoleObservable(RoleType.Employee);
    // this.localHre$ = this.common.prepareEmployeeByRoleObservable(RoleType.LocalHRE);

    // this.visaApprovers$ = this.common.prepareEmployeeByRoleObservable(RoleType.VisaApprover);
    // this.preboardingType$ = this.common.prepareLookupObservable(LookupTypeKeys.ONBOARDING_TYPES);
    // this.cancellationReason$ = this.common.prepareLookupObservable(LookupTypeKeys.CANCELLATION_REASON);
    this.passportType$ = this.common.prepareLookupObservable(LookupTypeKeys.PASSPORT_TYPES);
    this.officeLocation$ = this.common.prepareLookupObservable(LookupTypeKeys.OFFICE_LOCATION);
    // this.gosiRemovalRequesters$ = this.common.GetUsersByClaimValue('SAU-GOSIremoval-Create');
    // this.gosiAdditionRequestors$ = this.common.GetUsersByClaimValue('SAU-GOSIadditional-Create');
    // this.visaCancellationRequestors$ = this.common.GetUsersByClaimValue('SAU-VisaCancellation-Create');
    // this.visaPreApprovalrequestors$ = this.common.GetUsersByClaimValue('SAU-VisaPreApproval-Create');
    // this.exitIqamaTransfer$ = this.common.GetUsersByClaimValue('SAU-ExitIqamatransfer-Create');

  }

  getSteps(immUserProfileView: boolean): StepType[] {
    return [
      {
        label: "Step 1",
        fields: [
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getInputField(
                "firstName",
                "First name (as per passport)",
                setAsRequired(setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', setAsDisabled()))
              ),
              getInputField(
                "middleName",
                "Middle name (as per passport)",
                setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', setAsDisabled())
              ),
              getInputField("lastName", "Last name (as per passport)",
                setAsRequired(setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', setAsDisabled())))
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getSelectField("passportType.id", "Passport type",
                this.common.getSelectFieldOptions(
                  this.passportType$,
                  ''

                )
              ),

              getInputField("passportNumber", "Passport number"),

              getDateField("passportExpiryDate", "Passport expiry",
                setRegexValidation(
                  /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                  "Please enter a valid date in 'dd-mm-yyyy' format"

                )
              )


            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [

              getDateField("dateOfBirth", "Date of birth",
                setAsRequired(setRegexValidation(
                  /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                  "Please enter a valid date in 'dd-mm-yyyy' format",
                  MinMaxAgeMustBe(
                    10,
                    100,
                    'Date of birth cannot be in the past 10 years or in the future',

                  )
                )
                )),

              getInputField("gpn", "GPN", setAsDisabled()),
              getInputField("gui", "GUI", setAsDisabled()),
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getInputField("email", "Email", setAsDisabled()),
              getSelectField("officeLocationCountry.id",
                "Office location country",
                this.common.getSelectFieldOptions(this.officeLocationContries$, '', setAsDisabled())),
              getInputField("officeLocationName", "Office Location", setAsDisabled()),

            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getSelectField(
                "officeLE.id",
                "Office legal entity",
                this.common.getSelectFieldOptions(this.officeLegalEntities$, "officeLocationCountry.id", setAsDisabled())
              ),
              getSelectField(
                "serviceLine.id",
                "Service line",
                this.common.getSelectFieldOptions(this.serviceLines$, '', setAsDisabled())
              ),
              getSelectField(
                "subServiceLine.id",
                "Sub-service line",
                this.common.getSelectFieldOptions(this.subServiceLines$, "serviceLine.id",
                  setAsDisabled()
                )
              )
            ]

          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getSelectField(
                "job.rank",
                "Rank",
                this.common.getRankSelectFieldOptions(
                  setAsDisabled()
                )
              ),
              getSelectField(
                "job.jobCode",
                "Grade",
                this.common.getGradeSelectFieldOptions(setAsDisabled())
              ),
              getSelectField("gender.id", "Gender",
                this.common.getSelectFieldOptions(this.gender$, '', setAsRequired(setAsDisabled())))
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getSelectField(
                "nationalityTypeId.id", "Nationality type",
                //this.common.getSelectFieldOptions(this.nationalityType$, '', setAsRequired(setAsDisabledWhen(() => !this.isVisaApprover())))
               this.common.getSelectFieldOptions(this.nationalityType$, '', setAsRequired(setAsDisabledWhen(() => !this.isVisaApproverView())))
              ),
              getSelectField("nationality.id", "Nationality",
                this.common.getSelectFieldOptions(this.nationality$, '', setAsDisabled())),

              getSelectField(
                "dualCitizenship.id",
                "Dual citizenship",
                this.common.getSelectFieldOptions(this.yesNo$, '',
                )
              ),

              getSelectField(
                "secondNationality.id", "Second nationality",
                this.common.getSelectFieldOptionsExcept(this.nationality$, 'nationality.id',
                  setDisableWhen((model) => !isNullOrUndefined(model.dualCitizenship)
                    && model.dualCitizenship.id !== 1074,
                    setRequiredWhen((model) => !isNullOrUndefined(model.dualCitizenship)
                      && model.dualCitizenship.id === 1074)
                  ))
              ),
              getArrayPickerField('spouseDetails', 'Spouse details', this.spouseDetails('spouse', immUserProfileView), 'spouse', this.AddTooltipToControl(FieldTooltip.EmpProfileDependent), null, null, null, FieldTooltip.EmpProfileDependentHeader, immUserProfileView, true),
              getArrayPickerField('childrenDetails', 'Child details', this.childrenDetails('children', immUserProfileView), 'children', this.AddTooltipToControl(FieldTooltip.EmpProfileDependent), null, null, null, FieldTooltip.EmpProfileDependentHeader, immUserProfileView, true),

            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getInputField("placeofBirth", "Place of birth (City,Country)", setAsRequired()),
              getTelephoneField(
                "Mobile number",
                setAsRequired(),
                'col-md-4  pr-0 '),
              getSelectField(
                "maritalStatus.id",
                "Marital status",
                this.common.getSelectFieldOptions(this.maritalStatus$, '', setAsRequired())
              ),
            ]
          },

          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getSelectField("isGCCNational.id", " GCC National? ",
                this.common.getSelectFieldOptions(this.yesNo$, '', this.common.getGccNationalsBasedOnNationality(setAsDisabled()))),

              // getDateField("iqamaExpiryDate", "Iqama expiry date",
              //   setRegexValidation(
              //     /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
              //     "Please enter a valid date in 'dd-mm-yyyy' format",
              //     this.AddTooltipToControl(FieldTooltip.ProfileExpiryToolTip,
              //       setAsDisabledWhen(() => ![1048].includes(this.empOfficeLocationCountry()),
              //         setRequiredWhen(() => [1048].includes(this.empOfficeLocationCountry()) && [14570].includes(this.empNationalityType())))) // Iqama expiry date only for KSA               
              //   )

              // ),

              getDateField("labourCardExpiryDate", "Labour card/Work Permit expiry date",
                this.AddTooltipToControl(FieldTooltip.ProfileExpiryToolTip, setAsDisabled())

              ),
              
              getDateField("missionVisaExpiryDate", "Mission visa expiry date",
                setRegexValidation(
                  /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                  "Please enter a valid date in 'dd-mm-yyyy' format",
                  this.AddTooltipToControl(FieldTooltip.ProfileExpiryToolTip, setAsDisabled())
                  //setAsDisabledWhen(() => this.empOfficeLocationCountry() !== 1047)) // Mission visa expiry date only for ARE
                )
              ),


            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [

              // getDateField("employeeVisaExpiryDate", "Employment visa expiry date",
              //   setRegexValidation(
              //     /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
              //     "Please enter a valid date in 'dd-mm-yyyy' format",
              //     this.AddTooltipToControl(FieldTooltip.ProfileExpiryToolTip, setAsDisabled()))
              //   //setAsDisabledWhen(() => ![1047, 1049, 1050, 1051, 1052].includes(this.empOfficeLocationCountry()))) //Except KSA
              // ),


              // getDateField("workPermitExpiryDate", "Work permit expiry date",
              //   setRegexValidation(
              //     /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
              //     "Please enter a valid date in 'dd-mm-yyyy' format",
              //     this.AddTooltipToControl(FieldTooltip.ProfileExpiryToolTip,setAsDisabled() )
              //     //setAsDisabledWhen(() => ![1049, 1050].includes(this.empOfficeLocationCountry()))) // KWT and QAT
              //   )
              // ),
                getDateField("rpExpiryDate", "Residency Permit (RP) expiry date",
                setRegexValidation(
                  /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                  "Please enter a valid date in 'dd-mm-yyyy' format",
                  this.AddTooltipToControl(FieldTooltip.ProfileExpiryToolTip, setAsDisabledWhen(() => !this.isVisaApproverView(),
                        this.common.AcceptDateAfter(0, 'RP expiry date cannot be a past date', 'Residency Permit (RP) expiry', true,
                        this.common.AcceptDateBeforeYears(new Date(), 10, "RP expiry date should be within 10 years from current date")
                       ),
                )) 
                )),

              getInputField("pensionRegistrationNo", 'Pension registration number',
                this.AddTooltipToControl(FieldTooltip.ProfileExpiryToolTip, setAsDisabled())
                //setAsDisabledWhen(() => !this.isGCCNationals()))
              ),
              getDateField("pensionRegistrationDate", "Pension registration date",
                setRegexValidation(
                  /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                  "Please enter a valid date in 'dd-mm-yyyy' format",
                  this.AddTooltipToControl(FieldTooltip.ProfileExpiryToolTip, setAsDisabled()))
                // setAsDisabledWhen(() => !this.isGCCNationals())))
              ),
            ]

          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [

              // getDateField("civilIdExpiryDate", "Civil ID expiry date",
              //   setRegexValidation(
              //     /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
              //     "Please enter a valid date in 'dd-mm-yyyy' format",
              //     this.AddTooltipToControl(FieldTooltip.ProfileExpiryToolTip, setAsDisabled())
              //     //setAsDisabledWhen(() => this.empOfficeLocationCountry() !== 1050)) //KWT
              //   )
              // ),

              // getDateField("cprExpiryDate", "CPR expiry date",
              //   setRegexValidation(
              //     /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
              //     "Please enter a valid date in 'dd-mm-yyyy' format",
              //     this.AddTooltipToControl(FieldTooltip.ProfileExpiryToolTip, setAsDisabled())
              //     //setAsDisabledWhen(() => this.empOfficeLocationCountry() !== 1051)) //BHR
              //   )
              // ),
              getSelectField(
                "categoryOfJobOffer.id",
                "Job offer category",
                this.common.getCategoryOptions("", this.categoryOfJobOfferWithBehaviourSub$.pipe(map(x => x.filter(l => [12216, 12217].includes(l.id)))), '', setAsDisabled())
                //, setAsDisabledWhen(model => { return nullSafe<number>(() => model['officeLocationCountry'].id, -1) != 1047 }))
              ),
              getSelectField(
                "employeeCategory.id",
                "Employee category",
                this.common.getEmpCategoryOptions(this.employeeCategorys$, '', setAsDisabled())
                //setAsDisabledWhen(model => { return nullSafe<number>(() => model['officeLocationCountry'].id, -1) != 1047 }))
              ),
              getInputField(
                'labourCardNumber',
                "Labour card number", setAsDisabled()),
              //setAsDisabledWhen(model => { return nullSafe<number>(() => model['officeLocationCountry'].id, -1) != 1047 })),
              getSelectField(
                "contractType.id",
                "Type of MOL contract",
                this.common.getSelectFieldOptions(this.contractTypes$.pipe(map(x => x.filter(l => [6624, 6625].includes(l.id)))), '', setAsDisabled())
              ),
              getSelectField(
                "workPermitType.id",
                "Type of Work Permit",
                this.common.getSelectFieldOptions(this.workPermit$, '', setAsDisabled())
              ),
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              getDateField("officeJoiningDate", "Most recent hire date",
                setRegexValidation(
                  /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                  "Please enter a valid date in 'dd-mm-yyyy' format", setAsDisabled()
                )
              ),
              getDateField("firmJoiningDate", "Seniority start date",
                setRegexValidation(
                  /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                  "Please enter a valid date in 'dd-mm-yyyy' format", setAsDisabled()
                )
              ),
              getInputField("visanNoAndDesignation", "Visa designation", setAsDisabledWhen(() => !this.isVisaApproverView())),


            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [

              getInputField(
                'labourContractNoticePeriod',
                "Labour contract notice period (months)",
                setAsNumeric(checkRange(0, 6,
                  "Labour contract notice period(months) should not be more than 6 months", setAsDisabled()))),
              getInputField(
                'labourCardDuration',
                "Labour contract duration(months)",
                setAsNumeric(checkRange(0, 36,
                  "Labour contract Duration(months) should not be more than 36 months", setAsDisabled()))),
              getSelectField(
                "employeeStatus.id",
                "Is active employee ? ",
                this.common.getSelectFieldOptions(this.yesNo$, '', setAsDisabled())
              ),
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [

              getSelectField(
                "dependentsHaveValidVisa.id",
                "Do your dependents have valid residency permits/visa in your hiring office location?",
                this.common.getSelectFieldOptions(this.yesNo$, '', setRequiredWhen((model) => model.spouseDetails == null || model.spouseDetails == undefined ? model.childrenDetails == null || model.childrenDetails == undefined ? false : JSON.parse(model.childrenDetails).formData.length > 0 : model.childrenDetails == null || model.childrenDetails == undefined ? JSON.parse(model.spouseDetails).formData.length > 0 : JSON.parse(model.spouseDetails).formData.length > 0 || JSON.parse(model.childrenDetails).formData.length > 0))
              ),
              getInputField(
                'numberOfdependents',
                "Number of dependents currently residing with you",
                setAsNumeric(checkRange(0, 10,
                  "Number of dependents should not be more than 10 ", setRequiredWhen((model) => model.spouseDetails == null || model.spouseDetails == undefined ? model.childrenDetails == null || model.childrenDetails == undefined ? false : JSON.parse(model.childrenDetails).formData.length > 0 : model.childrenDetails == null || model.childrenDetails == undefined ? JSON.parse(model.spouseDetails).formData.length > 0 : JSON.parse(model.spouseDetails).formData.length > 0 || JSON.parse(model.childrenDetails).formData.length > 0
                    , setDisableWhen((model) => !isNullOrUndefined(model.dependentsHaveValidVisa)
                      && model.dependentsHaveValidVisa.id !== 1074)
                  )))),
              getSelectField(
                "typeOfVisa.id",
                "Visa Type",
                this.common.getSelectFieldOptions(this.typeOfVisa$.pipe(map(x => x.filter(l => l.id != null &&  ![15255, 15256].includes(l.id)))), '', setAsDisabled())),

            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [

              getSelectField(
                "visaAlignment.id",
                "Visa alignment",
                //this.common.getSelectFieldOptions(this.visaAlignment$, null, setAsRequired(setAsDisabledWhen(() => !this.isVisaApprover())))
                this.common.getSelectFieldOptions(this.visaAlignment$, null, setAsRequired(setAsDisabledWhen(() => !this.isVisaApproverView())))

              ),
                  
              getInputField(
                "emiratesId",
                "Residency Permit (RP)/National ID number",
                setRegexValidationWhen(
                  /^[0-9]{3}-[0-9]{4}-[0-9]{7}-[0-9]{1}$/,
                  "Please enter a valid Emirates id in the format 000-0000-0000000-0",
                  ((model) => ([1047].includes(model?.officeLocationCountry?.id) && model?.nationality?.id === 241)),
                  this.AddTooltipToControl(FieldTooltip.EmairatesorNationalId,setRequiredWhen(
                    (model) => ([1047,1048,1049,1050,1051,1052].includes(model?.officeLocationCountry?.id)),
                  ))
              )),
              getInputField(
                "labourPersonCode",
                "Labour person code", setAsDisabled()),
              // getInputField(
              //   "mohreJobTitle",
              //   "Work permit job title", setAsDisabled()),

              getSelectField(
                "mohreJobTitleId.id",
                "Work permit job title",
                this.common.getSelectFieldOptions(this.workpermitJobTitles$, '',
                  setAsDisabled())),
              getInputField(
                "workPermitCategory",
                "Work permit category", setAsDisabled()),
              getInputField(
                "workPermitJobCode",
                "Work permit job code", setAsDisabled()),                  
            ]
          },

        ]
      }];
  }

  loadLookups() {
   
    
  }
  private spouseDetails(_buttonAddText: string, immUserProfileView: boolean = false): FormlyFieldConfig[] {
    return (
      [
        {
          key: 'formData',
          type: 'repeat',
          templateOptions: {
            addText: `Add ${_buttonAddText}`,
            immUserProfileView: immUserProfileView
          },
          fieldGroupClassName: "row",
          fieldArray: {
            fieldGroup: [
              {
                fieldGroupClassName: "row",
                fieldGroup: [
                  getInputField(
                    "firstName",
                    "First name (as per passport)",
                    // tslint:disable-next-line: max-line-length
                    setAsRequired(setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', { className: 'col' }))
                  ),
                  getInputField(
                    "middleName",
                    "Middle name (as per passport)",
                    setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', { className: 'col' })
                  ),
                  getInputField("lastName", "Last name (as per passport)",
                    // tslint:disable-next-line: max-line-length
                    setAsRequired(setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', { className: 'col' }))
                  ),
                ]
              }
              ,
              {
                fieldGroupClassName: "row",
                fieldGroup: [
                  getSelectField("nationality.id", "Nationality", this.common.getSelectFieldOptionsEnableAllNationality(setAsRequired())),
                  getInputField("passportNumber", "Passport number", setAsRequired({ className: 'col-md-4 mb-3' })),

                  getDateField("passportExpiryDate", 'Passport expiry', setAsRequired(
                    setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                      "Please enter a valid date in 'dd-mm-yyyy' format")))
                ]
              },
              {
                fieldGroupClassName: "row",
                fieldGroup: [
                  // getDateField("dateOfBirth", "Date of birth", setAsRequired(
                  //   setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                  //     "Please enter a valid date in 'dd-mm-yyyy' format",
                  //     MinMaxAgeMustBe(10, 100,
                  //       'Date of birth cannot be in the past 10 years or in the future'
                  //       , { className: 'col-md-4 mb-3' })))),
                  getDateField("dateOfBirth", "Date of birth", setAsRequired(
                    setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                      "Please enter a valid date in 'dd-mm-yyyy' format",
                      this.common.AcceptDateAfterANDBeforeYears(new Date(),16,80,"Please enter a valid date of birth. Age must be between 16 and 80 years.")
                       ))),
                  getInputField("placeOfBirth", "Place of birth (City,Country)", setAsRequired()),
                  getSelectField("gender.id", "Gender", this.common.getSelectFieldOptions(this.gender$, '', setAsRequired())),
                  // getConfigurableTypeAhead("dependentCurrentLocation", 'Current location',
                  // this.addAllOfficeLocationTypeAheadEndPoint()
                  // ),
                  getSelectField(
                    "dependentCurrentLocation.id",
                    "Current location",
                    this.common.getSelectFieldOptionsEnableAllNationality(setAsRequired())
                  ),

                  getSelectField(
                    "visaStatus.id",
                    'Current visa status',
                    this.common.getSelectFieldOptions(this.currentVisaStatus$, '', setAsRequired())),

                getDateField(
                    "visaExpiryDate",
                    "Residency Permit (RP) expiry",
                    {
                      expressionProperties: setRequiredAndDisabledBasedOnNationalityType(14572, 'visaExpiryDate'),
                      ...setRegexValidation(
                        /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d{4}$/,
                        "Please enter a valid date in 'dd-mm-yyyy' format",                      
                          this.common.AcceptDateAfter(
                            0,
                            'RP expiry date cannot be a past date',
                            'Residency Permit (RP) expiry',
                            true,
                            this.common.AcceptDateBeforeYears(
                              new Date(),
                              10,
                              "RP expiry date should be within 10 years from current date"
                            )
                          
                        )
                      ),
                    }
                  ),
                ]
              },
              {
                fieldGroupClassName: "row",
                fieldGroup: [               
                    getSelectField("nationalityType.id", "Nationality type", this.common.getSelectFieldOptions(this.nationalityType$.pipe(map(item => item.filter(i =>
                    i.id!=null &&
                    [14570, 14571, 14572, 14573].includes(i.id)))), '',)),

                  getSelectField("isGCCNational.id", " GCC National? ",
                    this.common.getSelectFieldOptions(this.yesNo$, '', this.common.getGccNationalsBasedOnNationality(setAsDisabled()))),

                  getSelectField("passportType.id", "Passport type",
                    this.common.getSelectFieldOptions(this.passportType$, '')
                  )]
              },
              {
                fieldGroupClassName: "row",
                fieldGroup: [
                  getSelectField(
                    "dualCitizenship.id",
                    "Dual citizenship",
                    this.common.getSelectFieldOptions(this.yesNo$, '',
                    )
                  ),

                  getSelectField(
                    "secondNationality.id", "Second nationality",
                    this.common.getSelectFieldOptionsExceptWithValue(this.nationality$, 'nationality.id',
                      setDisableWhen((model) => !isNullOrUndefined(model.dualCitizenship)
                        && model.dualCitizenship.id !== 1074,
                        setRequiredWhen((model) => !isNullOrUndefined(model.dualCitizenship)
                          && model.dualCitizenship.id === 1074))

                    )
                  ),

                  // getDateField("cprExpiryDate", 'CPR expiry date',
                  //   setAsHiddenWhen((() => this.empOfficeLocationCountry() != 1051),
                  //     setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                  //       "Please enter a valid date in 'dd-mm-yyyy' format"
                  //     ))),

                  // getDateField("civilIdExpiryDate", "Civil ID expiry date",
                  //   setRegexValidation(
                  //     /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                  //     "Please enter a valid date in 'dd-mm-yyyy' format",
                  //     setAsHiddenWhen((() => this.empOfficeLocationCountry() != 1050)))),

                  getSelectField(
                    "isYourSpouseCurrentlyWorkingForEY.id",
                    "Is your spouse currently working for EY?",
                    this.common.getSelectFieldOptions(this.yesNo$, '', setAsRequired(),
                    )),
                    getInputField("spouseGUI", "Spouse GUI",
                      setRegexValidation(/^\d{1,10}$/, "Please enter numbers only (upto 10 digits)",
                          setAsHiddenWithoutValueWhen((model) => isNullOrUndefined(model.isYourSpouseCurrentlyWorkingForEY) || model.isYourSpouseCurrentlyWorkingForEY.id !== 1074,
                          setRequiredWhen((model) => !isNullOrUndefined(model.isYourSpouseCurrentlyWorkingForEY) && model.isYourSpouseCurrentlyWorkingForEY.id === 1074,
                          this.AddTooltipToControl(FieldTooltip.SpouseGUI)
                      )))),
                  
                  getSelectField("isMarriageCertUploaded.id", "Marriage Certificate Uploaded", this.common.getSelectFieldOptions(this.yesNo$, '', setAsDisabled()))
                  ,getTelephoneField(
                    "Spouse Mobile number",
                    null,
                    'col-md-4  pr-0 ',null,null,false)
                    ,getInputField("emailId", "Spouse Email", setRegexValidation(
                      /^\w+([\.]?[\-\w])*@\w+([\.-]?\w+)*(\.\w{2,})+$/,
                      'Please enter a valid email address',
                      null))
                ]
              }

            ]
          },
        },
      ]
    );
  }
  private childrenDetails(_buttonAddText: string, immUserProfileView: boolean = false): FormlyFieldConfig[] {
    return (
      [
        {
          key: 'formData',
          type: 'repeat',
          templateOptions: {
            addText: `Add ${_buttonAddText}`,
            immUserProfileView: immUserProfileView
          },
          fieldGroupClassName: "row",
          fieldArray: {
            fieldGroup: [
              {
                fieldGroupClassName: "row",
                fieldGroup: [
                  getInputField(
                    "firstName",
                    "First name (as per passport)",
                    // tslint:disable-next-line: max-line-length
                    setAsRequired(setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', { className: 'col' }))
                  ),
                  getInputField(
                    "middleName",
                    "Middle name (as per passport)",
                    setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', { className: 'col' })
                  ),
                  getInputField("lastName", "Last name (as per passport)",
                    // tslint:disable-next-line: max-line-length
                    setAsRequired(setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', { className: 'col' }))
                  ),
                ]
              },
              {
                fieldGroupClassName: "row",
                fieldGroup: [
                  getSelectField("nationality.id", "Nationality", this.common.getSelectFieldOptionsEnableAllNationality(setAsRequired())),
                  getInputField("passportNumber", "Passport number", setAsRequired({ className: 'col-md-4 mb-3' })),

                  getDateField("passportExpiryDate", 'Passport expiry', setAsRequired(
                    setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                      "Please enter a valid date in 'dd-mm-yyyy' format"
                    )))

                ]
              },
              {
                fieldGroupClassName: "row",
                fieldGroup: [
                  getDateField("dateOfBirth", "Date of birth", setAsRequired(
                    setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                      "Please enter a valid date in 'dd-mm-yyyy' format",
                      ValidateFutureDate('Date of birth cannot be in the future',
                        this.AddTooltipToControl(FieldTooltip.KSAVisaPreApprovalDateOfBirth)
                      )))),
                  getInputField("placeOfBirth", "Place of birth (City,Country)", setAsRequired()),
                  getSelectField("gender.id", "Gender", this.common.getSelectFieldOptions(this.gender$, '', setAsRequired())),
                  //   getConfigurableTypeAhead("dependentCurrentLocation", 'Current location',
                  //   this.addAllOfficeLocationTypeAheadEndPoint()
                  // ),
                  getSelectField(
                    "dependentCurrentLocation.id",
                    "Current location",
                    this.common.getSelectFieldOptionsEnableAllNationality(setAsRequired())
                  ),
                  getSelectField(
                    "visaStatus.id",
                    'Current visa status',
                    this.common.getSelectFieldOptions(this.currentVisaStatus$, '', setAsRequired())),

  
                  getDateField(
                    "visaExpiryDate",
                    "Residency Permit (RP) expiry",
                    {
                      expressionProperties: setRequiredAndDisabledBasedOnNationalityType(14572, 'visaExpiryDate'),
                    ...setRegexValidation(
                        /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d{4}$/,
                        "Please enter a valid date in 'dd-mm-yyyy' format",                    
                          this.common.AcceptDateAfter(
                            0,
                            'RP expiry date cannot be a past date',
                            'Residency Permit (RP) expiry',
                            true,
                            this.common.AcceptDateBeforeYears(
                              new Date(),
                              10,
                              "RP expiry date should be within 10 years from current date"
                            )
                          )
                     
                      ),
                    }
                  ),
               
                ]
              },
              {
                fieldGroupClassName: "row",
                fieldGroup: [
               getSelectField("nationalityType.id", "Nationality type", this.common.getSelectFieldOptions(this.nationalityType$.pipe(map(item => item.filter(i =>
                    [14570, 14571, 14572, 14573].includes(i.id)))), '',)),

                  getSelectField("isGCCNational.id", " GCC National? ",
                    this.common.getSelectFieldOptions(this.yesNo$, '', this.common.getGccNationalsBasedOnNationality(setAsDisabled()))),

                  getSelectField("passportType.id", "Passport type",
                    this.common.getSelectFieldOptions(this.passportType$, '')
                  )]
              },
              {
                fieldGroupClassName: "row",
                fieldGroup: [
                  getSelectField(
                    "dualCitizenship.id",
                    "Dual citizenship",
                    this.common.getSelectFieldOptions(this.yesNo$, '',
                    )
                  ),

                  getSelectField(
                    "secondNationality.id", "Second nationality",
                    this.common.getSelectFieldOptionsExceptWithValue(this.nationality$, 'nationality.id',
                      setDisableWhen((model) => !isNullOrUndefined(model.dualCitizenship)
                        && model.dualCitizenship.id !== 1074,
                        setRequiredWhen((model) => !isNullOrUndefined(model.dualCitizenship)
                          && model.dualCitizenship.id === 1074))
                    )
                  ),

                  // getDateField("cprExpiryDate", 'CPR expiry date',
                  //   setAsHiddenWhen((() => this.empOfficeLocationCountry() != 1051),
                  //     setRegexValidation(/^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                  //       "Please enter a valid date in 'dd-mm-yyyy' format"

                  //     ))),

                  // getDateField("civilIdExpiryDate", "Civil ID expiry date",
                  //   setRegexValidation(
                  //     /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[012])-\d\d\d\d$/,
                  //     "Please enter a valid date in 'dd-mm-yyyy' format",
                  //     setAsHiddenWhen((() => this.empOfficeLocationCountry() != 1050)
                  //     ))),
                      getTelephoneField(
                        "Child Mobile number",
                        null,
                        'col-md-4  pr-0 ',null,null,false)
                        ,getInputField("emailId", "Child Email", setRegexValidation(
                          /^\w+([\.]?[\-\w])*@\w+([\.-]?\w+)*(\.\w{2,})+$/,
                          'Please enter a valid email address',
                          null))
                ]
              }

            ]
          },
        },
      ]
    );
  }
  AddTooltipToControl(tooltipMessage: string, additionalConfig?): FormlyFieldConfig {
    const config: FormlyFieldConfig = {
      templateOptions: {
        tooltip: {
          content: tooltipMessage
        }
      },
      wrappers: ['tooltip-field']
    };
    return getMergedConfig(config, additionalConfig);
  }
  addAllOfficeLocationTypeAheadEndPoint(additionalConfig?: FormlyFieldConfig) {
    const config: FormlyFieldConfig = {
      templateOptions: {
        typeAheadEndPoint: (x) => this.common.getAllOfficeLocations(x)
      }
    };

    return getMergedConfig(config, additionalConfig);
  }
}
